import useAxios from "../../../Utils/useAxios";
import MailContain from "./MailContain";
import MailSidebar from "./MailSidebar";
import React, { Fragment, useEffect, useState } from "react";
import { Container, Row, Col } from "reactstrap";

const MailInboxContain = () => {
  const axiosInstance = useAxios();

  const [mailList, setMailList] = useState({});
  const [mailPage, setMailPage] = useState({});
  const [moduleList, setModuleList] = useState([]);
  const [moduleOpen, setModuleOpen] = useState(
    sessionStorage.getItem("moduleOpen") || "Transaksi"
  );
  const [IsOpen, setIsOpen] = useState(false);

  let isMounted = true;
  useEffect(() => {
    getModuleList();
    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    getDefaultMailList();
    getModuleCountList();
  }, [moduleList]);

  const resetMailPage = () => {
    moduleList?.forEach(async (module) => {
      setMailPage((prev) => ({ ...prev, [module.module]: 0 }));
    });
  };

  const getDefaultMailList = () => {
    resetMailPage();
    moduleList?.forEach(async (module) => {
      await axiosInstance
        .get(`notification/all/${module.module}?page=${0}`)
        .then((response) => {
          if (response.status === 200) {
            setMailList((prev) => ({
              ...prev,
              data: { ...prev.data, [module.module]: response.data },
            }));
          }
        })
        .catch((error) => console.error("Error fetching mail list: ", error));
    });
  };

  const addMailList = async (module) => {
    let currPage = mailPage[module] + 1;
    setMailPage((prev) => ({
      ...prev,
      [module]: currPage,
    }));

    await axiosInstance
      .get(`notification/all/${module}?page=${currPage}`)
      .then((response) => {
        if (response.status === 200) {
          setMailList((prev) => ({
            ...prev,
            data: {
              ...prev.data,
              [module]: [...prev.data[module], ...response.data],
            },
          }));
          if (response.data.length < 20) {
            setMailPage((prev) => ({
              ...prev,
              [module]: -1,
            }));
          }
        }
      })
      .catch((error) => console.error("Error fetching mail list: ", error));
  };

  const getModuleList = async () => {
    await axiosInstance
      .get("notification/modules/")
      .then((response) => {
        if (response.status === 200) {
          setModuleList(response.data);
        }
      })
      .catch((error) => console.error("Error fetching module list: ", error));
  };

  const getModuleCountList = async () => {
    await axiosInstance
      .get("notification/modules/count/")
      .then((response) => {
        if (response.status === 200) {
          setMailList((prev) => ({ ...prev, module: response.data }));
        }
      })
      .catch((error) => console.error("Error fetching module list: ", error));
  };

  const OnHandelClick = (module) => {
    setModuleOpen(module);
    sessionStorage.setItem("moduleOpen", module);
  };

  const mailReadMore = () => {
    if (hasNextPage(mailPage[moduleOpen])) {
      addMailList(moduleOpen);
    }
  };

  const hasNextPage = (page) => page >= 0;

  return (
    <Fragment>
      <Container fluid={true}>
        <div className="email-wrap">
          <Row>
            <Col xl="2" md="2" sm="2" className="box-col-4 xl-30">
              <MailSidebar
                moduleOpen={moduleOpen}
                IsOpen={IsOpen}
                OnHandelClick={OnHandelClick}
                moduleList={moduleList}
                mailList={mailList.module}
              />
            </Col>
            <Col xl="10" md="12" sm="10" className="box-col-8 xl-70">
              <MailContain
                filteredMailList={mailList.data && mailList.data[moduleOpen]}
                getMailList={getDefaultMailList}
                mailReadMore={mailReadMore}
                hasNext={mailPage[moduleOpen] >= 0}
              />
            </Col>
          </Row>
        </div>
      </Container>
    </Fragment>
  );
};

export default MailInboxContain;
